export default "__VITE_ASSET__DmLgYWkL__"